import axios from 'axios';

const API_URL = process.env.REACT_APP_BASE_URL;


export const getAgentList = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/agent-manager/v1/agent`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {    
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAllAgents = async (token, search = null, page = null, limit = null) => {
    try {
        let url = `${API_URL}/agent-manager/v1/agent`;
        const params = new URLSearchParams();
        
        if (search) params.append('search', search);
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        
        if (params.toString()) {
            url = `${url}?${params.toString()}`;
        }

        const response = await axios.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAvailableEndpoints = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/agent-manager/public/v1/endpoints`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getEndpointByNodeId = async (token, nodeId) => {
    try {
        const response = await axios.get(`${API_URL}/agent-manager/v1/endpoints/node/${nodeId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAgentById = async (token, agentId) => {
    try {
        const response = await axios.get(`${API_URL}/agent-manager/v1/agent/${agentId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const createAgent = async (token, agentData) => {
    try {
        const nodeId = (agentData.node_id && agentData.node_id.trim() !== '') 
            ? agentData.node_id 
            : "4c1d4bc0-f79f-4315-8acb-9bc7cd5de2e1";
        const transformedData = {
            name: agentData.name,
            node_id: nodeId,
            is_active: agentData.is_active !== undefined ? agentData.is_active : true,
            endpoint: agentData.endpoint || "",
            model: agentData.model || "",
            models: agentData.models || [""],
            language: agentData.language || "en",
            audio_input_enabled: agentData.audio_input_enabled !== undefined ? agentData.audio_input_enabled : false,
            speech_model: agentData.speech_model || "openai/whisper-large-v3",
            gpu_vendor: agentData.gpu_vendor || "GPU_VENDOR_NVIDIA",
            gpu_model: agentData.gpu_model || "GPU_MODEL_A100",
            num_of_gpus: agentData.num_of_gpus || 1
        };

        // Add system prompt if provided
        if (agentData.system_prompt) {
            transformedData.system_prompt = agentData.system_prompt;
        }

        const response = await axios.post(
            `${API_URL}/agent-manager/v1/agent`,
            transformedData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const updateAgent = async (token, agentId, agentData) => {
    try {
        const transformedData = {
            name: agentData.name,
            system_prompt: agentData.system_prompt || "",
            endpoint: agentData.endpoint || "",
            language: agentData.language || "en",
            model: agentData.model || "",
            models: agentData.models || [""],
            audio_input_enabled: agentData.audio_input_enabled !== undefined ? agentData.audio_input_enabled : true,
            speech_model: agentData.speech_model || ""
        };

        if (!agentData.useDefaultSystemPrompt && agentData.system_prompt) {
            transformedData.system_prompt = agentData.system_prompt;
        }

        const response = await axios.put(
            `${API_URL}/agent-manager/v1/agent/${agentId}`,
            transformedData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const deleteAgent = async (token, agentId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/agent-manager/v1/agent/${agentId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAgentTemplates = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/agent-manager/v1/templates`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};
